function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.638 16.648l-5.71-5.28a1.379 1.379 0 00-.945-.368c-.355 0-.695.133-.945.368l-5.644 5.28a1.206 1.206 0 00-.394.884c0 .332.142.65.394.884.519.482 1.357.482 1.877 0l4.712-4.408 4.712 4.408c.248.23.583.36.932.36a1.38 1.38 0 00.945-.36c.26-.226.415-.54.427-.871a1.2 1.2 0 00-.36-.897z",
  id: "path-chevron-up"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-chevron-up",
  transform: "translate(-8 -11)",
  fillRule: "evenodd"
})));